import { Checkbox as MantineCheckbox } from '@mantine/core'
import { ComponentProps, ForwardedRef, forwardRef, ReactNode } from 'react'
import { Colors } from '../style/colors'
import { TrackingLabel } from '../types/tracking'
import { WithClassName } from '../types/utils'

type CheckboxVariant = 'primary' | 'alert'

type CheckboxProps = WithClassName &
  Omit<ComponentProps<'input'>, 'onChange' | 'size'> & {
    checked: boolean
    disabled?: boolean
    indeterminate?: boolean
    label?: ReactNode
    onChange?: (checked: boolean) => void
    variant?: CheckboxVariant
    trackingLabel: TrackingLabel
  }

const VariantInputClasses: { [key in CheckboxVariant]: string } = {
  primary:
    'border-king enabled:hover:bg-topaze enabled:hover:border-cobalt checked:bg-king checked:border-king indeterminate:bg-king indeterminate:border-king enabled:checked:hover:bg-cobalt enabled:checked:hover:border-cobalt enabled:indeterminate:hover:bg-cobalt enabled:indeterminate:hover:border-cobalt',
  alert:
    'border-cherry enabled:hover:bg-mew enabled:hover:border-alert checked:bg-cherry checked:border-cherry indeterminate:bg-cherry indeterminate:border-cherry enabled:checked:hover:bg-alert enabled:checked:hover:border-alert enabled:indeterminate:hover:bg-alert enabled:indeterminate:hover:border-alert',
}

const BaseCheckbox = ({ checked, disabled, indeterminate, label, onChange, className, variant = 'primary', trackingLabel, ...props }: CheckboxProps, ref: ForwardedRef<HTMLInputElement>) => {
  return (
    <MantineCheckbox
      {...props}
      ref={ref}
      size={'0.938rem'}
      radius={3}
      iconColor={Colors.White}
      checked={checked}
      indeterminate={indeterminate}
      disabled={disabled}
      label={label}
      onChange={() => onChange?.(indeterminate ? true : !checked)}
      data-tracking={trackingLabel}
      className={className}
      styles={{ input: { boxSizing: 'border-box', width: 'var(--checkbox-size)', height: 'var(--checkbox-size)' } }}
      classNames={{
        root: 'cursor-pointer inline-flex',
        body: 'items-center',
        // prevent the box from shrinking inside narrow / overflow-hidden containers
        inner: 'flex-none w-[var(--checkbox-size)] h-[var(--checkbox-size)] min-w-[var(--checkbox-size)]',
        input: `cursor-pointer border-2 bg-white disabled:cursor-not-allowed disabled:bg-platinum disabled:border-silver disabled:checked:bg-silver disabled:checked:border-silver disabled:indeterminate:bg-silver disabled:indeterminate:border-silver ${VariantInputClasses[variant]}`,
        // tighten the space between the box and its label
        label: 'cursor-pointer select-none text-base leading-5 ps-1.5',
      }}
    />
  )
}

export const Checkbox = forwardRef<HTMLInputElement, CheckboxProps>(BaseCheckbox)
